import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  collapsed: false,
  mobileOpen: false,
  activeItem: null,
  notificationData: {
    new: 0,
    updated: 0
  }
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggleCollapse: (state) => {
      state.collapsed = !state.collapsed;
      // Save to localStorage for persistence
      localStorage.setItem('sidebarCollapsed', JSON.stringify(state.collapsed));
    },
    setCollapsed: (state, action) => {
      state.collapsed = action.payload;
      localStorage.setItem('sidebarCollapsed', JSON.stringify(state.collapsed));
    },
    toggleMobileMenu: (state) => {
      state.mobileOpen = !state.mobileOpen;
    },
    setMobileOpen: (state, action) => {
      state.mobileOpen = action.payload;
    },
    setActiveItem: (state, action) => {
      state.activeItem = action.payload;
    },
    setNotificationData: (state, action) => {
      state.notificationData = action.payload;
    },
    initializeSidebar: (state) => {
      // Initialize from localStorage
      const savedCollapsed = localStorage.getItem('sidebarCollapsed');
      if (savedCollapsed !== null) {
        state.collapsed = JSON.parse(savedCollapsed);
      }
    }
  }
});

export const {
  toggleCollapse,
  setCollapsed,
  toggleMobileMenu,
  setMobileOpen,
  setActiveItem,
  setNotificationData,
  initializeSidebar
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
